import React, { useEffect, useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import 'materialize-css'
import { Container, Card, Row, Col, Preloader } from 'react-materialize'

import { useTokenCittadino } from "../components/hooks/useTokenCittadino"

export const AutenticazionePage = () => {
    const debug = process.env.REACT_APP_DEBUG === "true"

    const { setToken } = useTokenCittadino()

    const history = useHistory()
    const location = useLocation()
    const hash = location.hash.replace('#','').split('&')


    const hashParams = useMemo(
        () => {
            const hp = {}

            hash.forEach(element => {
                let splitted = element.split('=')
                hp[splitted[0]] = splitted[1]
            });
        
            if (debug) console.log(hp)
            return hp
        },
        [hash, debug]
    )


    const checkToken = useCallback(
        () => {
            fetch(process.env.REACT_APP_SERVER_URL + 'cittadino/check_token', {
                method: 'POST',
                body: JSON.stringify({token: hashParams.access_token})
            })
                .then(res => res.json())
                .then(res => {
                    if (debug) console.log(res)
                    if (res.valid) {
                        setToken(hashParams.access_token)
                        history.push("/gestione_cittadino/anagrafica")
                    } else {
                        history.push("/")
                    }
                })
        },
        [setToken, history, hashParams, debug],
    )


    useEffect(() => {
        checkToken()
    }, [checkToken])



    return (
        <Container className="center">
            <Card title="VERIFICA AUTENTICAZIONE">
                <Row>
                    <Col className="center" s={12}>
                        <Preloader active color="green" flashing={false} size="big" />
                    </Col>
                </Row>
            </Card>
        </Container>
    )
}